"use client";

import { CampaignCard, BlogCard } from "@/components/featured/common";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";
import DynamicStats from "@/components/DynamicStats";
import RouteCard from "@/components/pages/ferry/cards/RouteCard";
import IconTextCard from "@/components/pages/ferry/cards/IconTextCard";
import ImageCardWrapper from "@/components/pages/bus/cards/ImageCardWrapper";

export const componentRegistry = {
  OpportunitiesCardWrapper,
  CampaignCard,
  BlogCard,
  DynamicStats,
  RouteCard,
  IconText: IconTextCard,
  ImageCardWrapper,
};

export const itemPropMapping = {
  OpportunitiesCardWrapper: "item",
  CampaignCard: "item",
  BlogCard: "post",
  RouteCard: "item",
  IconText: "item",
  ImageCardWrapper: "item",
};
